import React from "react";
import { LandingPage } from "../../assets/CommonAssets";

function WelcomePage() {
  const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
  const [userDashboards, setUserDashboards] = React.useState([]);
  const [uiComponent, setUiComponent] = React.useState(null);
  const [currentTime, setCurrentTime] = React.useState();
  const [currentDate, setCurrentDate] = React.useState();
  const [dateValue, setDateValue] = React.useState(new Date());
  let dashboardType = loggedUser?.userDashboard?.[0];
  const [welcomeMsg, setWelcomeMsg] = React.useState(null);

  function handleDateTime() {
    let today = new Date();
    let day = today.getDate();
    let month = today.toLocaleString("default", { month: "long" });
    let year = today.getFullYear();
    setCurrentDate(day + " " + month + " " + year);
    let hours = today.getHours();
    let minutes = today.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    setCurrentTime(hours + ":" + minutes + " " + ampm);
  }

  function handleWelcomeMsg() {
    let currentTimeHour = dateValue.getHours();
    if (currentTimeHour < 12) {
      setWelcomeMsg("Good Morning !");
    } else if (currentTimeHour >= 12 && currentTimeHour < 16) {
      setWelcomeMsg("Good Afternoon !");
    } else {
      setWelcomeMsg("Good Evening !");
    }
  }

  React.useEffect(() => {
    handleDateTime();
    handleWelcomeMsg();
    const welcometimer = setInterval(() => {
      setDateValue(new Date());
      handleWelcomeMsg();
      handleDateTime();
    }, 60 * 1000);
    const datetimer = setInterval(() => {
      handleDateTime();
    }, 1000);
    return () => {
      clearInterval(welcometimer, datetimer);
    };
  }, []);
  return (
    <div>
      <div className="py-16  tracking-wider">
        <div className="grid xl:grid-cols-3 gap-8 w-full ">
          <div className="col-span-1 flex flex-col xl:justify-start xl:whitespace-nowrap ">
            <div className="text-customBlue text-5xl xl:text-4xl lg:text-5xl xl:mt-[50%] 2xl:mt-[50%]  2xl:text-5xl font-semibold flex justify-center xl:justify-start  xl:px-20 ">
              {loggedUser?.role === "Super Admin"
                ? "Hey! Super Admin, Please Wait..."
                : `Hello , `}
            </div>
            <div className=" text-5xl xl:text-4xl lg:text-5xl  2xl:text-5xl tracking-wider mt-4 flex justify-center xl:justify-start  xl:px-20 ">
              {welcomeMsg}
            </div>
          </div>
          <div className="xl:col-span-2 flex justify-center items-center">
            <LandingPage />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;
